'use strict';

import versioner from '../versioner';
import process from './process';
import processPhase2 from './processPhase2';

versioner['ug_sewer_on_call'] = {process: process}
versioner['ug_sewer_night_crew'] = {process: process}

versioner['ug_sewer_phase2_generic'] = {process: processPhase2}
versioner['ug_sewer_weekday_pm'] = {process: processPhase2}
versioner['ug_sewer_friday_pm'] = {process: processPhase2}
versioner['ug_sewer_saturday_am'] = {process: processPhase2}
versioner['ug_sewer_saturday_pm'] = {process: processPhase2}
versioner['ug_sewer_sunday_am'] = {process: processPhase2}
versioner['ug_sewer_sunday_pm'] = {process: processPhase2}
versioner['ug_sewer_on_call_supervisor_phase_2'] = {process: processPhase2}

const MODULE_NAME = 'daupler.incidents.versions.ug_sewer';

export default MODULE_NAME;
